import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import Pagination from "../common/Pagination";
import { BiEditAlt } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoEyeOutline, IoKeySharp } from "react-icons/io5";
import TemplateModal from "./TemplateModal";
import DeleteConfirmationDltModal from "./DeleteConfirmationDltModal";
import DetailModal from "../../components/common/DetailModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import Button from "../customButton/Button";
import AddIcon from "../../../src/assets/Icons/AddIcon.svg";
import ViewMoreIcon from "../../assets/Icons/view-more 1.png";
import SecurityIcon from "../../assets/Icons/security icon.png";
import LeftCircle from "../../assets/Icons/Left Circle.svg";
import RightCircle from "../../assets/Icons/Right Circle.svg";
import SuccessTick from "../../assets/Icons/correct-success-tick.png";

const SuccessModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-[16px] p-6 w-[505px] h-[290px] relative flex flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          <img
            src={SuccessTick}
            alt="success icon"
            className="w-[77px] h-[77px] mb-4"
          />
          <h2 className="text-2xl font-semibold text-[#495057] mb-2">
            Success
          </h2>
          <p className="text-[#495057] font-semibold text-center mb-6">
            {message}
          </p>
          <button
            onClick={onClose}
            className="px-4 py-2 text-[#00b6ce] font-medium border-1 border-[#00b6ce] rounded-[8px] hover:bg-[#00b6ce] hover:text-white transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

// Existing TemplateKeyModal component
const TemplateKeyModal = ({ isOpen, onClose, templateKey }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-[16px] p-6 w-full max-w-md relative">
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="rightImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <img
              src={SecurityIcon}
              alt="security icon"
              className="w-[40px] h-[40px] mr-4"
            />
            <h2 className="text-lg font-semibold text-[#00B6CE]">SMS Key</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-4xl cursor-pointer z-20"
          >
            &times;
          </button>
        </div>
        <div className="mb-6">
          <p className="text-[#000000] break-all">{templateKey}</p>
        </div>
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="px-4 py-2 text-[#00b6ce] font-medium border-1 border-[#00b6ce] rounded-[8px] hover:bg-[#00b6ce] hover:text-white transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const Template = ({ openModal, customerCode, name }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize] = useState(10);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [detailsContent, setDetailsContent] = useState("");
  const [detailsTitle, setDetailsTitle] = useState("");
  const [openTemplateKeyModal, setOpenTemplateKeyModal] = useState(false);
  const [templateKey, setTemplateKey] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    fetchTemplateData(1);
  }, []);

  const handleAuthKey = (temp) => {
    setTemplateKey(temp.templateKey);
    setOpenTemplateKeyModal(true);
  };

  const handleViewTemplate = (temp, type) => {
    setSelectedTemplate({
      name: temp?.templateName,
      id: temp?.sendorId,
      tempId: temp?.templateId,
      type: temp?.templateType,
      customerCode: temp?.customerCode,
      customerName: temp?.customerName,
      entityId: temp?.entityId,
      smsContent: temp?.smsContent,
      smsDesc: temp?.smsDesc,
    });
    setModalType(type);
    setOpenPopup(true);
  };

  const handleClose = () => {
    setOpenPopup(false);
    setOpenDeleteModal(false);
    setOpenDetailsModal(false);
    setOpenTemplateKeyModal(false);
    setOpenSuccessModal(false);
  };

  const fetchTemplateData = async (page) => {
    const data = {
      username: loggedInUserName,
      customerCode: customerCode,
    };

    try {
      setLoading(true);
      const response = await axiosPostApi(
        `${apiList.DLT_FETCH_TEMPLATE}?pageSize=${pageSize}&pageNo=${page}`,
        data
      );
      setTemplate(response?.data?.data || []);
      setPageDetails(response?.data?.pageDetails || null);
    } catch (error) {
      console.error("Failed to fetch template data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    openModal();
  };

  const handleShowFullContent = (content) => {
    setDetailsTitle("Details");
    setDetailsContent(content);
    setOpenDetailsModal(true);
  };

  const handleShowFullDescription = (description) => {
    setDetailsTitle("Details");
    setDetailsContent(description);
    setOpenDetailsModal(true);
  };

  const handleDeleteId = (temp) => {
    setDeletedId({
      username: loggedInUserName,
      customerCode: temp?.customerCode,
      templateId: temp?.templateId,
      status: "3",
    });
    setOpenDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.DELETE_TEMPLATEID, deletedId);
      if (response?.status === 200 && response.data.status === true) {
        setSuccessMessage("Template Deleted Successfully");
        setOpenSuccessModal(true);
        handleClose();
        await fetchTemplateData(1);
      } else if (response.data.respCode === "01") {
        setOpenTemplateKeyModal(false);
        toast.error(
          response.data.message || "Please check the details and try again.",
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        handleClose();
      }
    } catch (error) {
      setOpenTemplateKeyModal(false);
      toast.error(
        "An error occurred while deleting the template. Please try again later.",
        {
          position: "top-right",
          autoClose: 2000,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateUpdate = async () => {
    setSuccessMessage("Template Updated Successfully");
    setOpenSuccessModal(true);
    await fetchTemplateData(1);
  };

  const getActionItems = (temp) => {
    const actions = [];

    if (user?.data?.userRole === "CUST") {
      actions.push({
        icon: <BiEditAlt style={{ marginRight: "10px" }} />,
        label: "Edit",
        onClick: (e) => {
          e.stopPropagation();
          handleViewTemplate(temp, "modify");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleViewTemplate(temp, "view");
      },
    });

    if (user?.data?.userRole === "CUST") {
      actions.push({
        icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
        label: "Delete",
        onClick: (e) => {
          e.stopPropagation();
          handleDeleteId(temp);
        },
      });
    }

    actions.push({
      icon: <IoKeySharp style={{ marginRight: "10px" }} />,
      label: "Template Key",
      onClick: (e) => {
        e.stopPropagation();
        handleAuthKey(temp);
      },
    });

    return actions;
  };

  return (
    <div className="template-container">
      <div className="flex first-tab-controls justify-end">
        {user?.data?.userRole === "CUST" && (
          <Button
            label="Add"
            icon={AddIcon}
            onClick={handleSwitch}
            className="pr-2"
          />
        )}
      </div>
      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        <div className="table-container !bg-[#FFFFFF] !shadow-none !px-0">
          {template.length > 0 ? (
            <>
              <div className="table-wrapper">
                <table className="custom-table">
                  <thead className="bg-[#F1FFFF]">
                    <tr>
                      <th className="!border-b-0">Sr No</th>
                      <th className="!border-b-0">Entity ID</th>
                      <th className="!border-b-0">Sender ID</th>
                      <th className="!border-b-0">Template ID</th>
                      <th className="!border-b-0">Template Name</th>
                      <th className="!border-b-0">Status</th>
                      <th className="!border-b-0">Created Date-Time</th>
                      <th className="!border-b-0">Type</th>
                      <th className="!border-b-0">Content</th>
                      <th className="!border-b-0">Description</th>
                      <th className="!border-b-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {template.map((temp, index) => (
                      <tr key={temp.templateId}>
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{temp.entityId || "-"}</td>
                        <td>{temp.sendorId || "-"}</td>
                        <td>{temp.templateId || "-"}</td>
                        <td>{temp.templateName || "-"}</td>
                        <td>
                          <span
                            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border`}
                            style={{
                              backgroundColor:
                                temp.status === "ACTIVE"
                                  ? "#e6f9ec"
                                  : temp.status === "BLOCKED"
                                  ? "#fdecea"
                                  : "#f0f0f0",
                              borderColor:
                                temp.status === "ACTIVE"
                                  ? "#55cd69"
                                  : temp.status === "BLOCKED"
                                  ? "#fb4a3f"
                                  : "#6c757d",
                              color:
                                temp.status === "ACTIVE"
                                  ? "#2e9b47"
                                  : temp.status === "BLOCKED"
                                  ? "#d4352c"
                                  : "#6c757d",
                            }}
                          >
                            <span
                              className="w-2 h-2 rounded-full mr-2"
                              style={{
                                backgroundColor:
                                  temp.status === "ACTIVE"
                                    ? "#55cd69"
                                    : temp.status === "BLOCKED"
                                    ? "#fb4a3f"
                                    : "#6c757d",
                              }}
                            ></span>
                            {temp.status || "-"}
                          </span>
                        </td>
                        <td>{temp.createdDate || "-"}</td>
                        <td>{temp.templateType || "-"}</td>
                        <td>
                          {temp.smsContent ? (
                            <>
                              {temp.smsContent.substring(0, 10)}...
                              <span
                                className="view-more"
                                onClick={() =>
                                  handleShowFullContent(temp.smsContent)
                                }
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                  color: "#00B6CE",
                                  textDecoration: "underline",
                                }}
                                title="View full content"
                              >
                                View More
                              </span>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {temp.smsDesc ? (
                            temp.smsDesc.length > 10 ? (
                              <>
                                {temp.smsDesc.slice(0, 10)}...
                                <span
                                  className="view-more"
                                  onClick={() =>
                                    handleShowFullDescription(temp.smsDesc)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                    color: "#00B6CE",
                                    textDecoration: "underline",
                                  }}
                                  title="View full Description"
                                >
                                  View More
                                </span>
                              </>
                            ) : (
                              temp.smsDesc
                            )
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="actions" style={{ overflow: "visible" }}>
                          <Popover>
                            {({ open, close }) => (
                              <>
                                <Popover.Button
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    display: "inline-block",
                                    padding: "0 10px",
                                    background: "none",
                                    border: "none",
                                  }}
                                >
                                  ⋮
                                </Popover.Button>
                                <Transition
                                  as={React.Fragment}
                                  enter="transition ease-out duration-200"
                                  enterFrom="opacity-0 translate-y-1"
                                  enterTo="opacity-100 translate-y-0"
                                  leave="transition ease-in duration-150"
                                  leaveFrom="opacity-100 translate-y-0"
                                  leaveTo="opacity-0 translate-y-1"
                                >
                                  <Popover.Panel
                                    style={{
                                      position: "absolute",
                                      zIndex: 2000,
                                      minWidth: "220px",
                                      backgroundColor: "#ffffff",
                                      boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                                      border: "1px solid #d1d5db",
                                      borderRadius: "8px",
                                      padding: "8px 0",
                                      overflow: "visible",
                                    }}
                                  >
                                    {getActionItems(temp).map((action, idx) => (
                                      <div
                                        key={idx}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px 20px",
                                          cursor: "pointer",
                                          color: "#333",
                                          fontSize: "15px",
                                          fontWeight: "500",
                                          transition: "background-color 0.2s",
                                          whiteSpace: "nowrap",
                                        }}
                                        onMouseEnter={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            "#f0f0f0")
                                        }
                                        onMouseLeave={(e) =>
                                          (e.currentTarget.style.backgroundColor =
                                            "#ffffff")
                                        }
                                        onClick={(e) => {
                                          action.onClick(e);
                                          close();
                                        }}
                                      >
                                        {action.icon}
                                        <span>{action.label}</span>
                                      </div>
                                    ))}
                                  </Popover.Panel>
                                </Transition>
                              </>
                            )}
                          </Popover>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-3">
                <Pagination
                  currentPage={currentPage}
                  totalCount={pageDetails?.totalRecords || 0}
                  pageSize={pageSize}
                  onPageChange={(page) => {
                    setCurrentPage(page);
                    fetchTemplateData(page);
                  }}
                />
              </div>
            </>
          ) : (
            <p className="no-data-message">No data available</p>
          )}
        </div>
      )}
      <TemplateModal
        show={openPopup}
        handleClose={handleClose}
        customerCode={customerCode}
        name={name}
        TempDetails={selectedTemplate}
        modalType={modalType}
        handleShowTable={handleTemplateUpdate}
      />
      <DeleteConfirmationDltModal
        isOpen={openDeleteModal}
        onClose={handleClose}
        handleDelete={handleDelete}
        loading={loading}
      />
      <DetailModal
        open={openDetailsModal}
        onClose={handleClose}
        text={detailsContent}
        icon={ViewMoreIcon}
        headingText={detailsTitle}
      />
      <TemplateKeyModal
        isOpen={openTemplateKeyModal}
        onClose={handleClose}
        templateKey={templateKey}
      />
      <SuccessModal
        isOpen={openSuccessModal}
        onClose={handleClose}
        message={successMessage}
      />
    </div>
  );
};

export default Template;
